class OntarioObstetricalRecommendedImmuniprophylaxis {
    public NegativeBloodRhesus?: boolean = null;
    public RhesusImmuneGlobulingGivenDate?: Date;
    public AdditionalDoseRhesusImmuneGlobulingGivenDate?: Date;
    public IsInfluenzaDiscussed?: boolean = null;
    public IsInfluenzaVaccineReceived?: boolean = null;
    public IsInfluenzaVaccineDeclined?: boolean = null;
    public IsPertussisUpToDate?: boolean = null;
    public IsPertussisDiscussed?: boolean = null;
    public PertussisUpdateYear?: number;
    public IsPertussisVaccineReceived?: boolean = null;
    public IsPertussisVaccineDeclined?: boolean = null;
    public IsRubellaPostPartumVaccineDiscussed?: boolean = null;
    public IsOtherPostPartumVaccineDiscussed?: boolean = null;
    public OtherPostPartumVaccineDiscussed: string;
    public IsHepBProphylaxisNeededForNewBorn?: boolean = null;
    public IsHivProphylaxisNeededForNewBorn?: boolean = null;

    constructor(fields?: Partial<OntarioObstetricalRecommendedImmuniprophylaxis>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalRecommendedImmuniprophylaxis };
